import { Injectable, Injector } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
import { ApiEndpoints } from 'src/app/ApiEndpoints';

export interface ReportStructureItem {
  component: string;
  order: number;
}

export interface ReportPayload {
  portfolio_id: number;
  meta: {
    title: string;
    subtitle: string;
  };
  structure: ReportStructureItem[];
}

@Injectable({
  providedIn: 'root'
})
export class ReportService extends DataService {

  constructor(injector: Injector) {
    super(injector);
  }

  generateReport(payload: ReportPayload): Observable<HttpResponse<Blob>> {
    const url = `${environment.apiURL}/${ApiEndpoints.reportGenerate}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.post(url, payload, { headers, responseType: 'blob', observe: 'response' });
  }
}
